import { useInfiniteQuery } from "@tanstack/react-query";

import { api, type ListResponse, queryKeys } from "../api/client";

const PAGE_SIZE = 100;

export function useMyFiles(order: "asc" | "desc") {
  return useInfiniteQuery({
    queryKey: queryKeys.myFiles(order),
    initialPageParam: undefined as string | undefined,
    queryFn: ({ pageParam }) => api.listMyFiles({ order, limit: PAGE_SIZE, afterId: pageParam }),
    getNextPageParam: (last: ListResponse) =>
      last.items.length === PAGE_SIZE ? last.items[last.items.length - 1].id : undefined,
  });
}
